import { createAction, props } from '@ngrx/store';

import {
  CreateEnquiriesTenantSettingsDto,
  CreateEnquiryRequestDto,
  EnquiryDto,
  EnquiryTenantSettingsDto,
  PutEnquiriesTenantSettingsRequestParams,
} from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';

export class EnquiriesTenantSettingsActions extends CaEntityActionsFactory<
  EnquiryTenantSettingsDto,
  CreateEnquiriesTenantSettingsDto,
  CreateEnquiriesTenantSettingsDto,
  BaseFilterType
> {
  constructor() {
    super('enquiriesTenantSettings');
  }
}

export const EnquiriesTenantSettings = new EnquiriesTenantSettingsActions();
